import constants from "../constants";

export const getDashboardMetrics = async (accessToken: string) => {
  const response = await fetch(
    `${constants.BACKEND_API_ENDPOINT}/internal/dashboard`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );
  if (!response.ok) {
    throw new Error("Failed to fetch dashboard metrics");
  }
  return response.json();
};
